import {FormFieldProps} from '..'

const email: FormFieldProps = {
  name: 'email',
  type: 'text',
  label: 'Email',
  required: true,
  placeholder: 'cool@keanureeves.me',
  help: 'Address to receive app notifications.',
}

const name: FormFieldProps = {
  name: 'name',
  type: 'text',
  label: 'Name',
  required: true,
  help: 'Your account name to sign in with.',
}

const recover: FormFieldProps = {
  ...email,
  help: 'Enter address to begin reset process.',
}

const captcha: FormFieldProps = {
  name: 'captcha',
  type: 'text',
  label: 'Human Challenge',
  required: true,
  help: 'Needed to help prevent abuse.',
}

const password: FormFieldProps = {
  name: 'password',
  type: 'showable-password',
  label: 'Password',
  help: 'Must be at least 6 characters.'
}

export const SignInForm = {recover, name: {...name, help: ''}, password: {...password, help: ''}}
export const AddTeamMemberForm = {name, email}
export const SignUpForm = {name, password, email, captcha}
export const UpdateUserForm = {name, email, password}
